import { useBlocker } from 'react-router-dom';
import type { Blocker } from 'react-router-dom';

export type UseFormDirtyOptions = {
  /** True when the form has unsaved changes (e.g. react-hook-form formState.isDirty). */
  isDirty: boolean;
  /**
   * True while a network operation is in flight. Suppresses the blocker so
   * post-submit navigations and FSM transitions (which refetch + reset the
   * form) do not race with the dirty state being cleared.
   */
  isPending?: boolean;
};

// Wraps React Router 6 useBlocker so a navigation is only blocked when the
// form is dirty AND the destination pathname differs (hash-only changes pass
// through). Returns the underlying Blocker so the caller can render its own
// ConfirmModal bound to blocker.proceed / blocker.reset.
export function useFormDirty({ isDirty, isPending = false }: UseFormDirtyOptions): Blocker {
  return useBlocker(({ currentLocation, nextLocation }) => {
    if (!isDirty || isPending) return false;
    return currentLocation.pathname !== nextLocation.pathname;
  });
}
